import { StoreFrontScriptManagerDetailsContext } from '../context'
import ScriptForm from '../sections/forms/ScriptForm'
import useScriptDetails from '../hooks/useScriptDetails'
import useScriptOperations from '../hooks/useScriptOperations'
import usePermission from '../../../hook/usePermission'

export default function ScriptDetails({scriptId}: any) {
  const {script, isLoading} = useScriptDetails(scriptId)
  const {updateScript, isOperationLoading, createScript} = useScriptOperations()
  const {hasPermission} = usePermission()
  const hasWritePermission = hasPermission('storefronts_script manager', 'write')

  const contextValue = {
    script,
    isLoading,
    isOperationLoading,
    updateScript,
    createScript,
    hasWritePermission,
  }

  return (
    <StoreFrontScriptManagerDetailsContext.Provider value={contextValue}>
      <ScriptForm />
    </StoreFrontScriptManagerDetailsContext.Provider>
  )
}
